/* eslint-disable  */
import { FavoriteBorderOutlined, ShoppingBasket } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { FaHandHoldingUsd } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import {
  authActionCreators,
  userDataActionCreators,
} from "../../../../../service/action-creators";
import CidiSymbol from "../../../../CidiSymbol";
import Modal from "../../../../Modal/Modal";

function SectionOne() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [formData, setFormData] = React.useState(null);

  const { ChangePassword } = bindActionCreators(authActionCreators, dispatch);
  const { GetTotalFunds, GetAppliedLoans } = bindActionCreators(
    userDataActionCreators,
    dispatch
  );
  const user = useSelector((state) => state.user);

  const { funds, cart, totalFunds, favoriteProducts, myAppliedLoans, orders } =
    user;

  console.log("totalFunds", totalFunds);
  const [open, setOpen] = React.useState(false);
  const [openRejectedLoan, setRejectedLoan] = React.useState(false);
  const [openRejectedOrder, setRejectedOrder] = React.useState(false);
  const [openLoanRestriction, setOpenLoanRestriction] = React.useState(false);
  const [loanMessage, setLoanMessage] = React.useState("");
  const [loanSelected, setLoanSelected] = React.useState("");
  const [orderSelected, setOrderSelected] = React.useState("");
  const [loanRestrictionMessage, setLoanRestrictionMessage] =
    React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target.value });
  };

  // Function to check if user can apply for a new loan
  const canApplyForLoan = () => {
    // console.log('Checking loan eligibility...');
    // console.log('User object:', user);
    // console.log('myAppliedLoans:', user?.myAppliedLoans);
    // console.log('myAppliedLoans length:', user?.myAppliedLoans?.length);

    if (!user?.myAppliedLoans || user.myAppliedLoans.length === 0) {
      // console.log('No applied loans found - user can apply');
      return { canApply: true, message: "" };
    }

    // Check for loans that are not rejected or paid
    const restrictiveLoan = user.myAppliedLoans.find((loan) => {
      // console.log('Checking loan:', loan);
      // console.log('Loan status:', loan.status);
      return loan.status !== "rejected" && loan.status !== "paid";
    });

    console.log("Restrictive loan found:", restrictiveLoan);

    if (restrictiveLoan) {
      let message = "";

      // Customize message based on current loan status
      switch (restrictiveLoan.status) {
        case "submitted":
          message =
            "You have already submitted a loan application. Please wait for it to be processed.";
          break;
        case "booked":
          message =
            "Your loan application has been booked. Please wait for further processing.";
          break;
        case "initiated":
          message = "Your loan has been initiated. Please wait for completion.";
          break;
        case "authorized":
          message =
            "Your loan has been authorized. Please wait for disbursement.";
          break;
        default:
          message = `You have an active loan application with status: ${restrictiveLoan.status}. Please wait for it to be completed or contact support.`;
      }

      console.log("Blocking loan application with message:", message);
      return {
        canApply: false,
        message: message,
      };
    }

    // User can apply - no restrictive loans found
    console.log("No restrictive loans found - user can apply");
    return { canApply: true, message: "" };
  };

  // Function to check if user can place a new order
  // const canPlaceOrder = () => {
  //   if (!user?.orders || user.orders.length === 0) {
  //     return { canApply: true, message: "" };
  //   }

  //   // Check for orders that are not rejected or completed
  //   const restrictiveOrder = user.orders.find((order) => {
  //     return order.status !== "rejected" && order.status !== "shipped";
  //   });

  //   if (restrictiveOrder) {
  //     let message = `You already have an order with status: ${restrictiveOrder.status}. Please wait for it to complete.`;
  //     return {
  //       canApply: false,
  //       message: message,
  //     };
  //   }

  //   return { canApply: true, message: "" };
  // };

  // Handle loan application click
  const handleLoanApplicationClick = () => {
    const loanCheck = canApplyForLoan();

    if (loanCheck.canApply) {
      history.push("/apply-loan-personal_info");
    } else {
      setLoanRestrictionMessage(loanCheck.message);
      setOpenLoanRestriction(true);
    }
  };

  const handlePlaceOrderClick = () => {
    // const orderCheck = canPlaceOrder();

    // if (orderCheck.canApply) {
    history.push("/upnmg-shopping-mall");
    // } else {
    //   setLoanRestrictionMessage(orderCheck.message);
    //   setOpenLoanRestriction(true);
    // }
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    if (
      (!formData?.confirmPassword || formData?.password !== "",
      !formData?.old_password !== "")
    ) {
      ChangePassword(formData);
      setOpen(false);
    } else {
      toast.error("Make sure to enter new password and confirm password");
    }
    setOpen(false);
  };

  useEffect(() => {
    GetTotalFunds();
    GetAppliedLoans();
  }, []);

  useEffect(() => {
    const loans = user.myAppliedLoans.map((loan) => {
      if (loan?.rejected.length > 0 && loan?.rejected[0].editFormChecked) {
        setRejectedLoan(true);
        setLoanMessage(loan?.rejected[0]?.message);
        setLoanSelected(loan);
      }
    });

    const orderArr = user.orders.map((order) => {
      if (
        order?.rejected.length > 0 &&
        (order?.rejected[0].editFormChecked ||
          order?.rejected[0].editFormAndProductChecked)
      ) {
        setRejectedOrder(true);
        setLoanMessage(order?.rejected[0]?.message);
        setOrderSelected(order);
        console.log("order", order);
      }
    });
  }, [user.myAppliedLoans]);

  const device = () => {
    return window.innerWidth < 1080;
  };
  const [isMobile, setIsMobile] = useState(device);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setIsMobile(device);
    });
    return 0;
  }, []);

  return (
    <div className="SectionOneMainPageDisplay">
      {!isMobile && (
        <div className="statisticsDisplay ">
          <div className="box">
            <div
              className="iconContainer"
              style={{
                background:
                  "linear-gradient(to bottom, var(--grayColor) 20%, var(--grayDeep) 100%)",
              }}
            >
              <FaHandHoldingUsd size={25} className="icon" />
            </div>
            <div>
              <div>Total Contributions</div>
              <h3 className="font-bold mt-1">
                <CidiSymbol /> {Number(totalFunds).toFixed(2)}
              </h3>
            </div>
          </div>
          <div className="box active" onClick={() => history.push({})}>
            <div
              className="iconContainer"
              style={{
                background: "white",
              }}
            >
              <FavoriteBorderOutlined size={25} className="icon" />
            </div>
            <div>
              <div>favourite Products</div>
              <h3 className="font-bold mt-1">{favoriteProducts?.length}</h3>
            </div>
          </div>
          <div className="box">
            <div
              className="iconContainer"
              style={{
                background:
                  "linear-gradient(to bottom, var(--primary) 20%, var(--primaryLite) 100%)",
              }}
            >
              <ShoppingBasket size={25} className="icon" />
            </div>
            <div>
              <div>Shopping Cart</div>
              <h3 className="font-bold mt-1">{cart?.length}</h3>
            </div>
          </div>
        </div>
      )}

      {isMobile && (
        <div
          className=""
          style={{
            display: "flex",
            justifyContent: "flex-end",
            position: "absolute",
            right: "20px",
            top: "65px",
          }}
        >
          <h3
            className=""
            style={{
              background: "var(--primaryColor)",
              color: "white",
              fontSize: ".7rem",
              padding: "2px 20px",
              borderRadius: "4pc",
            }}
          >
            <div style={{}}>Contribution</div>
            <span style={{ fontWeight: "bolder" }}>
              {" "}
              <CidiSymbol /> {Number(totalFunds).toFixed(2)}
            </span>
          </h3>
        </div>
      )}

      <div className="activityLinksCards">
        <div
          className="box"
          style={{ cursor: "pointer" }}
          onClick={handlePlaceOrderClick}
        >
          <div className="content">
            <div
              className="imgCover"
              style={{
                backgroundPosition: "100%",
              }}
            >
              <img src="/images/shopping-cart.png" alt="car" />
            </div>
            <h2>UPNMG Mart</h2>
            <p>Visit our shop</p>
          </div>
        </div>
        <div className="box" onClick={handleLoanApplicationClick}>
          <div className="content">
            <div className="imgCover">
              <img src="/images/loan.png" alt="car" />
            </div>
            <h2>Apply loan</h2>
            <p>Apply for loan today</p>
          </div>
        </div>
        <div
          className="box"
          style={{ cursor: "pointer" }}
          onClick={() => history.push("/profile")}
        >
          <div className="content">
            <div className="imgCover">
              <img src="/images/profile.png" alt="car" />
            </div>
            <h2>My Profile</h2>
            <p>Edit your profile</p>
          </div>
        </div>
        <div
          className="box"
          style={{ cursor: "pointer" }}
          onClick={() => history.push("/fund-increment")}
        >
          <div className="content">
            <div className="imgCover">
              <img src="/images/fund-increase.png" alt="car" />
            </div>
            <h2>Increase / Decrease</h2>
            <p>Increase or decrease fund</p>
          </div>
        </div>
        <div
          className="box"
          style={{ cursor: "pointer" }}
          onClick={() => history.push("/my-orders-and-purchase")}
        >
          <div className="content">
            <div className="imgCover">
              <img src="/images/order-more.png" alt="car" />
            </div>
            <h2>Orders & More</h2>
            <p>View your items</p>
          </div>
        </div>

        <div
          className="box"
          style={{ cursor: "pointer" }}
          onClick={() => history.push("/my-applied-loans")}
        >
          <div className="content">
            <div className="imgCover">
              <img src="/images/applied-loan.png" alt="car" />
            </div>
            <h2>Applied Loans</h2>
            <p>View your loans</p>
          </div>
        </div>

        <div className="box" onClick={() => history.push("/message")}>
          <div className="content">
            <div className="imgCover">
              <img src="/images/chat.png" alt="car" />
            </div>
            <h2>Messenger</h2>
            <p>Message UPNMG </p>
          </div>
        </div>

        <div
          className="box"
          style={{ cursor: "pointer" }}
          onClick={() => history.push("/my-cart")}
        >
          <div className="content">
            <div
              className="imgCover"
              style={{
                backgroundPosition: "100%",
              }}
            >
              <img src="/images/grocery-cart.png" alt="car" />
            </div>
            <h2>My Cart</h2>
            <p>Your saved products</p>
          </div>
        </div>
        <div
          className="box"
          style={{ cursor: "pointer" }}
          onClick={() => history.push("/favourites")}
        >
          <div className="content">
            <div
              className="imgCover"
              style={{
                backgroundPosition: "100%",
              }}
            >
              <img src="/images/favourite.png" alt="car" />
            </div>
            <h2>Favorites</h2>
            <p>Your saved products</p>
          </div>
        </div>
        <div
          className="box"
          style={{ cursor: "pointer" }}
          onClick={handleClickOpen}
        >
          <div className="content">
            <div
              className="imgCover"
              style={{
                backgroundPosition: "100%",
              }}
            >
              <img src="/images/reset-password.png" alt="car" />
            </div>
            <h2>Change Password</h2>
            <p>Change your Password</p>
          </div>
        </div>
        <div
          className="box"
          style={{ cursor: "pointer" }}
          onClick={() => history.push("/renew_pin")}
        >
          <div className="content">
            <div
              className="imgCover"
              style={{
                backgroundPosition: "100%",
              }}
            >
              <img src="/images/reset-password.png" alt="car" />
            </div>
            <h2>Pin Renewal</h2>
            <p>Fill form for PIN Renewal</p>
          </div>
        </div>
      </div>

      {/* Change Password Modal */}
      {open && (
        <Modal
          title={"Change Password"}
          width={isMobile ? "85%" : "35%"}
          closeModal={setOpen}
        >
          <div className="modalBody">
            <div>
              <label htmlFor="old_password">Old Password</label>
              <input
                type={"password"}
                placeholder={"Old password"}
                name="old_password"
                id="old_password"
                onChange={handleChange}
                className="form-control mb-4"
              />
            </div>
            <div>
              <label htmlFor="newPassword">New Password</label>
              <input
                type={"password"}
                placeholder={"new password"}
                name="password"
                id="newPassword"
                onChange={handleChange}
                className="form-control mb-4"
              />
            </div>
            <div>
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type={"password"}
                placeholder={"confirm new password"}
                name="confirmPassword"
                id="confirmPassword"
                onChange={handleChange}
                className="form-control"
              />
            </div>
          </div>
          <div className="modalButton">
            <div className="btnCover">
              <button type="button" className="modalBtn" onClick={handleSubmit}>
                Change
              </button>
              <button
                data-modal-toggle=""
                type="button"
                onClick={() => setOpen(false)}
                className="cancelBtn"
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Loan Restriction Modal */}
      {openLoanRestriction && (
        <Modal
          title={"Loan Application Restricted"}
          width={isMobile ? "85%" : "35%"}
          closeModal={setOpenLoanRestriction}
        >
          <div className="modalBody">
            <div className="text-center">
              <p>{loanRestrictionMessage}</p>
            </div>
          </div>
          <div className="modalButton">
            <div className="btnCover">
              <button
                type="button"
                onClick={() => setOpenLoanRestriction(false)}
                className="modalBtn"
              >
                OK
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Rejected Loan Modal */}
      {openRejectedLoan && (
        <Modal
          title={"Rejected Loan"}
          width={isMobile ? "85%" : "35%"}
          closeModal={setRejectedLoan}
        >
          <div className="modalBody">
            <div>{loanSelected?.rejected[0]?.message}</div>
          </div>
          <div className="modalButton">
            <div className="btnCover">
              <button
                type="button"
                className="modalBtn"
                onClick={() =>
                  history.push({
                    pathname: "/edit-loan-form",
                    state: { loan_id: loanSelected?._id },
                  })
                }
              >
                Edit Loan Form
              </button>
              <button
                data-modal-toggle=""
                type="button"
                onClick={() => setRejectedLoan(false)}
                className="cancelBtn"
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Rejected Order Modal */}
      {openRejectedOrder && (
        <Modal
          title={"Rejected Order"}
          width={isMobile ? "85%" : "35%"}
          closeModal={setRejectedOrder}
        >
          <div className="modalBody">
            <div>{orderSelected?.rejected[0]?.message}</div>
          </div>
          <div className="modalButton">
            <div className="btnCover">
              <button
                type="button"
                className="modalBtn"
                onClick={() =>
                  history.push({
                    pathname: "/edit-order-form",
                    search: `?order_id=${orderSelected?._id}`,
                  })
                }
              >
                Edit Mart Form
              </button>
              <button
                data-modal-toggle=""
                type="button"
                onClick={() => setRejectedOrder(false)}
                className="cancelBtn"
              >
                Close
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
}

export default SectionOne;
